import React from 'react';

import { ReactComponent as NotFound } from '../../../assets/logos/not_found.svg';
import { Button, Layout } from '../../../components';
import { useAuth } from '../../../hooks/useAuth';
import useRedirect from '../../../hooks/useRedirect';
import { RoutesPaths } from '../../../routes';
import { GridContainer, Grid, RightGrid } from './styles';

export const SessionNotFound: React.FC = () => {
  const redirect = useRedirect();
  const { user } = useAuth();

  return (
    <Layout
      headerProtect
      hideFloatingButton
      hideFooter
      hideBackbar
      hideInstructionModal
      titlePage={'Erro Interno'}
    >
      <GridContainer>
        <Grid>
          <NotFound />
        </Grid>
        <Grid>
          <RightGrid>
            <h1>404...</h1>
            <h2>Página não encontrada!</h2>
            <p>
              O link no qual você clicou pode estar quebrado ou a página pode
              ter sido removida.
            </p>
            <div>
              <Button
                variant="solid"
                onClick={() => redirect(RoutesPaths.home)}
              >
                {user ? 'Ir para a home' : 'Login'}
              </Button>
            </div>
          </RightGrid>
        </Grid>
      </GridContainer>
    </Layout>
  );
};
